module.exports = __webpack_public_path__ + "img/zip.bf528fa.svg";